function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 8.8999C13.5523 8.8999 14 8.45219 14 7.8999C14 7.34762 13.5523 6.8999 13 6.8999V8.8999ZM0.292894 7.1928C-0.0976305 7.58332 -0.0976305 8.21648 0.292894 8.60701L6.65686 14.971C7.04738 15.3615 7.68054 15.3615 8.07107 14.971C8.46159 14.5804 8.46159 13.9473 8.07107 13.5568L2.41421 7.8999L8.07107 2.24305C8.46159 1.85252 8.46159 1.21936 8.07107 0.828835C7.68054 0.43831 7.04738 0.43831 6.65686 0.828835L0.292894 7.1928ZM13 6.8999L1 6.8999V8.8999L13 8.8999V6.8999Z",
  fill: "#7E8897"
});

function SvgBackSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackSmall);
export default __webpack_public_path__ + "static/media/backSmall.f324eb3f.svg";
export { ForwardRef as ReactComponent };